export default __webpack_public_path__ + "static/media/20.e3b0b3e6.gif";